<template>
    <div :style="getStyles()" class="spacer"></div>
</template>

<script>
    export default {
        name: "Spacer",
        mounted() {
            this.windowHeight = window.innerHeight;

            setTimeout(() => {
                window.addEventListener('resize', this.onResize);
            }, 200);
        },
        data() {
            return {
                windowHeight: 0,
                windowWidth: 0,
                diff: 0
            }
        },
        methods: {
            getStyles: function () {
                return {
                    height: this.diff + 'px'
                }
            },
            onResize: function () {
                this.windowHeight = window.innerHeight;
                this.windowWidth = window.innerWidth;

                this.calculate();
            },
            calculate: function () {

                this.diff = 0;

                this.$nextTick(() => {
                    let newDiff = this.windowHeight - document.body.clientHeight;

                    if(newDiff < 0) {
                        this.diff = 0;
                    }
                    else {
                        this.diff = newDiff
                    }
                });
            }
        },
        watch: {
            windowHeight: function () {
                this.calculate();
            },
            windowWidth: function () {
                this.calculate();
            }
        }
    }
</script>

<style scoped>

</style>